module.exports = __webpack_public_path__ + "img/GongWaves assembly.317c4f28.jpg";